import calendarEvent from './models/calendarEvent.model';
import dish from './models/dish.model';
import marketProduct from './models/marketProduct.model';
import radioStation from './models/playerRadio.model';
import rdsUser from './models/rdsUser.model';
import reservation from './models/reservation.model';
import notification from './models/notification.model';
import driverShift from './models/driverShift.model';

const IMG_MAX_WIDTH = 720;
const IMG_MAX_HEIGTH = 384;

const dishCategories = [
  {
    name: 'primi',
    cssClass: 'primi',
    label: 'Primi',
    description: 'Risotti, zuppe, pasta, farro…',
    singular: 'primo',
    singularArticle: 'il',
    mainIcon: require('./assets/images/mensa/primi.svg'),
    menuIcon: require('./assets/images/mensa/Icona_primi_menu_laterale.svg')
  },
  {
    name: 'panini',
    cssClass: 'panini',
    label: 'Panini',
    description: 'Panini, pizzette, tramezzini…',
    singular: 'panino',
    singularArticle: 'il',
    mainIcon: require('./assets/images/mensa/panini.svg'),
    menuIcon: require('./assets/images/mensa/Icona_pizza_menu_laterale.svg')
  },
  {
    name: 'contorni',
    cssClass: 'contorni',
    label: 'Contorni',
    description: 'Insalate, verdure cotte…',
    singular: 'contorno',
    singularArticle: 'il',
    mainIcon: require('./assets/images/mensa/contorni.svg'),
    menuIcon: require('./assets/images/mensa/Icona_contorni_menu_laterale.svg')
  },
  {
    name: 'secondi',
    cssClass: 'secondi',
    label: 'Secondi',
    description: 'Carne, pesce…',
    singular: 'secondo',
    singularArticle: 'il',
    mainIcon: require('./assets/images/mensa/secondo.svg'),
    menuIcon: require('./assets/images/mensa/salmon.svg')
  },
  {
    name: 'piatti freddi',
    cssClass: 'piatti-freddi',
    label: 'Piatti freddi',
    description: 'Insalate, affettati…',
    singular: 'piatto freddo',
    singularArticle: 'il',
    mainIcon: require('./assets/images/mensa/piatti_freddi.svg'),
    menuIcon: require('./assets/images/mensa/Icona_piatti_freddi_menu_laterale.svg')
  },
  {
    name: 'frutta',
    cssClass: 'frutta',
    label: 'Frutta',
    description: 'Frutta e yogurt…',
    singular: 'frutta',
    singularArticle: 'la',
    mainIcon: require('./assets/images/mensa/frutta.svg'),
    menuIcon: require('./assets/images/mensa/Icona_frutta_yogurtmenu_laterale.svg')
  }
];

const features = [
  { name: 'Rubrica', url: '/rubrica' },
  { name: 'Navetta', url: '/navetta', romeOnly: true },
  { name: 'Mensa', url: '/mensa', romeOnly: true },
  { name: 'Market', url: '/market' },
  { name: 'Eventi', url: '/eventi' },
  { name: 'Benefits', url: '/benefits', romeOnly: true },
  { name: 'E-learning', url: '/e-learning' },
  { name: 'Beauty', url: '/beauty', romeOnly: true },
  { name: 'Barbecue', url: '/barbecue', romeOnly: true },
  { name: 'Bike', url: '/bike', romeOnly: true },
  { name: 'Palestra', url: '/palestra', romeOnly: true },
  { name: 'Chat', url: '/chat' }
  // { name: 'Test tornelli', url: '/test-tornelli' }
];

const benefits = [
  {
    title: 'Assicurazione sanitaria Unisalute',
    link: {
      text: 'www.unisalute.it',
      url: 'https://www.unisalute.it'
    }
  },
  {
    title: 'Convenzione Campus Bio medico',
    link: {
      text: 'informazioni aggiuntive',
      url: '/campus-biomedico'
    }
  },
  {
    title: 'RDS: Tutti pazzi per il Welfare',
    link: {
      text: 'scopri le offerte dedicate a te',
      url: 'https://eudaimon.force.com/welfare2/EudLoginTuttiPazziPerIlWelfare'
    }
  }
];

const AUTISTI = [
  { name: 'Andrea Labrozzi', id: 'a.labrozzi@rds.it' },
  { name: 'Stefano Notarantonio', id: 's.notarantonio@rds.it' },
  // { name: 'Davide Russo', id: 'd.russo@rds.it' }
];

const REGOLAMENTI = [
  { route: 'barbecue', url: 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/regolamenti/Regolamento-barbecue.pdf' },
  { route: 'navetta', url: 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/regolamenti/ORARI+NAVETTA+-+RIFERIMENTI+TELEFONICI.docx' },
  { route: 'bike', url: 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/regolamenti/REGOLAMENTO+BICICLETTE+RDS.pdf' },
  { route: 'palestra', url: 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/regolamenti/Regolamento+palestra+RDS+21.06.2016.docx' },
  { route: 'beauty', url: 'https://rds-life-dev-templates.s3-eu-west-1.amazonaws.com/regolamenti/Regolamento-barbecue.pdf' }
];
const CALENDAR_ID = 'rds.it_2e4jcjohob7nfcpkq6tocrms3s@group.calendar.google.com';
// const CALENDAR_ID = 'rds.it_6d682sc9kbnv6e5217ng2l6qco@group.calendar.google.com'

export default {
  IMG_MAX_WIDTH: IMG_MAX_WIDTH,
  IMG_MAX_HEIGTH: IMG_MAX_HEIGTH,
  restBackendUrl: 'https://apilife.betards.ninja/data',
  indexedDbSchema: 'rdsLife',
  indexedDbSchemaVersion: 5,
  production: false,
  models: [
    { name: 'rdsUser', cacheObject: 'users', objectStoreName: 'rdsUser', class: rdsUser },
    { name: 'radioStation', cacheObject: 'radioStations', objectStoreName: 'radioStation', class: radioStation },
    { name: 'calendarEvent', cacheObject: 'events', objectStoreName: 'calendarEvent', class: calendarEvent },
    { name: 'reservation', cacheObject: 'reservations', objectStoreName: 'reservation', class: reservation },
    { name: 'marketProduct', cacheObject: 'products', objectStoreName: 'marketProduct', class: marketProduct, inject: ['users'] },
    { name: 'dish', cacheObject: 'dishes', objectStoreName: 'dish', class: dish, inject: ['users'] },
    { name: 'notification', cacheObject: 'notifications', objectStoreName: 'notification', class: notification },
    { name: 'driverShift', cacheObject: 'driverShifts', objectStoreName: 'driverShift', class: driverShift }
  ],
  dishCategories: dishCategories,
  features: features,
  store: 'restStore',
  calendarId: CALENDAR_ID,
  regolamenti: REGOLAMENTI,
  benefits: benefits,
  autisti: AUTISTI,
  // BEACON_UUID: '11e44f09-4ec4-407e-9203-cf57a50fbce0' // test
  BEACON_UUID: 'acfd065e-c3c0-11e3-9bbe-1a514932ac01' // prod
};
